import { useEffect, useState } from 'react'

/**
 * Returns a debounced copy of `value` that only updates after the input has
 * been stable for `delay` milliseconds. Useful for live-search inputs so we
 * don't fire a backend request on every keystroke.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handle)
  }, [value, delay])

  return debounced
}
